<app-menu-toggle
  tooltip="Dark theme"
  [active]="darkTheme"
  icon="dark"
  (click)="setDarkTheme()"
>
</app-menu-toggle>
